<template>
  <div class="pb-5">
    <nav-bar/>
    <sidebar-toggle-button/>
    <chat-page/>
    <ticket-button/>

    <!-- SIDEBAR -->
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow" v-if="$store.state.isSidebarOpen">
      <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link navbar-text" href="#/TransferPending">
              {{$t('TransferCompleted.sidebar.pending')}}
            </a>
            <span v-if="pending.length > 0" class="pull-right badge badge-default">{{ pending.length }}</span>
          </li>
          <li class="nav-item" id="current">
            <a class="nav-link navbar-text" href="#/TransferCurrent">
              {{$t('TransferCompleted.sidebar.completed')}}
            </a>
          </li>
      </ul>
    </div>

    <!-- ORDER STATUS -->
    <order-status-counter
      class="mt-5 mx-2"
      :filterResults="filterResults"
      :processedArray="transfers"
      @updatedNewCount="computed_newCount">
    </order-status-counter>


    <table-element
      :isShowFilter="true"
      :title="$t('TransferCompleted.title')"
      :fields="fieldsObj"
      :arrOfElement="transfers"
      :sortSpacing="1"
      :isShowSelectAll="false"
      class="card mx-2 mt-4 mb-5"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(order, index) in content.results"
        class="table-element_hover text-center"
        :key="order['.key']"
        :class="{
          'drop': order.status === 'Drop',
          'cancel': order.status === 'Cancel',
          'waiting': order.status === 'Attente',
          'pick': order.status === 'Pick',
          'transit': order.status === 'Transit',
          'dispatch': order.status === 'Dispatch',
          'reject': order.status === 'Reject',
          'inspection': order.status === 'Inspection',
          'ordered': order.status === 'Transférée'
          }">
          <td>
            <a :href="'#/OrderInfo?orderId=' + order['.key']">
              <input type="button" class="btn btn-kne-orange pull-right " :value="$t('TransferCompleted.view')">
            </a>
          </td>
          <td class="nowrap"><p class="table-fix-width">{{order.transpName || '-'}}</p></td>
          <td>{{order.orderRef || '-'}}</td>
          <td>{{order['.key'] || '-'}}</td>
          <td>{{order.vin || '-'}}</td>
          <td>{{getDate(order.creationDate) || '-'}}</td>
          <td class="nowrap"><p class="table-fix-width">{{order.transmitterName || '-'}}</p></td>
          <td class="nowrap"><p class="table-fix-width">{{order.receiverName || '-'}}</p></td>
          <td>
            <span v-if="order.status === 'Dispatch'">{{$t('Search.status.dispatch')}}</span>
            <span v-if="order.status === 'Processing'">{{$t('Search.status.processing')}}</span>
            <span v-if="order.status === 'Pick'">{{$t('Search.status.pick')}}</span>
            <span v-if="order.status === 'Waiting'">{{$t('Search.status.waiting')}}</span>
            <span v-if="order.status === 'Transit'">{{$t('Search.status.transit')}}</span>
            <span v-if="order.status === 'Drop'">{{$t('Search.status.drop')}}</span>
            <span v-if="order.status === 'Cancel'">{{$t('Search.status.canceled')}}</span>
            <span v-if="order.status === 'Terminée'">{{$t('Search.status.finished')}}</span>
            <span v-if="order.status === 'Transférée'">{{$t('Search.status.ordered')}}</span>
            <span v-if="order.status === 'Reject'">{{$t('Search.status.rejected')}}</span>
            <span v-if="order.status === 'Inspection'">{{$t('Search.status.inspection')}}</span>
          </td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <transition-group name="fade">
          <div class="card my-3 mx-2" v-for="transfer in content.results" :key="transfer['.key']" :class="{'drop': transfer.status === 'Drop', 'cancel': transfer.status === 'Cancel','waiting': transfer.status === 'Waiting','pick': transfer.status === 'Pick','transit': transfer.status === 'Transit','dispatch': transfer.status === 'Dispatch','reject': transfer.status === 'Reject', }">
            <div class="card-header m-2">
              <h4>{{transfer['.key']}}</h4>
              <h6><i class="fa fa-calendar"></i>{{getDate(transfer.creationDate)}}</h6>
              <h6 v-if="transfer.status === 'Dispatch'"><i class="fa fa-exclamation"></i>{{$t('Search.status.dispatch')}}</h6>
              <h6 v-if="transfer.status === 'Processing'"><i class="fa fa-exclamation"></i>{{$t('Search.status.processing')}}</h6>
              <h6 v-if="transfer.status === 'Pick'"><i class="fa fa-exclamation"></i>{{$t('Search.status.pick')}}</h6>
              <h6 v-if="transfer.status === 'Waiting'"><i class="fa fa-exclamation"></i>{{$t('Search.status.waiting')}}</h6>
              <h6 v-if="transfer.status === 'Transit'"><i class="fa fa-exclamation"></i>{{$t('Search.status.transit')}}</h6>
              <h6 v-if="transfer.status === 'Drop'"><i class="fa fa-exclamation"></i>{{$t('Search.status.drop')}}</h6>
              <h6 v-if="transfer.status === 'Cancel'"><i class="fa fa-exclamation"></i>{{$t('Search.status.canceled')}}</h6>
              <h6 v-if="transfer.status === 'Terminée'"><i class="fa fa-exclamation"></i>{{$t('Search.status.finished')}}</h6>
              <h6 v-if="transfer.status === 'Transférée'"><i class="fa fa-exclamation"></i>{{$t('Search.status.transfered')}}</h6>
              <h6 v-if="transfer.status === 'Reject'"><i class="fa fa-exclamation"></i>{{$t('Search.status.rejected')}}</h6>
              <h6 v-if="transfer.status === 'Inspection'"><i class="fa fa-exclamation"></i>{{$t('Search.status.inspection')}}</h6>
            </div>
            <div class="m-2">
              <h6><i class="fa fa-asterisk"></i>{{transfer.orderRef || '-'}}</h6>
              <h6><i class="fa fa-building"></i>{{transfer.transpName || '-'}}</h6>
              <h6><i class="fa fa-car"></i>{{transfer.vin || '-'}}</h6>
              <h6><i class="fa fa-home"></i>{{transfer.transmitterName || '-'}}</h6>
              <h6><i class="fa fa-truck"></i>{{transfer.receiverName || '-'}}</h6>
              <a  id="action" :href="'#/OrderInfo?orderId=' + transfer['.key']">
                <input type="button" class="btn btn-kne-orange pull-right " :value="$t('TransferCompleted.view')">
              </a>
            </div>
          </div>
        </transition-group>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />

  </div>
</template>

<script>
  import Modal from '../module/interface-components/Modal.vue'
  import regularInput from '../module/basic-components/regularInput.vue'
  import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
  import regularTextarea from '../module/basic-components/regularTextarea.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import Search from '../module/special-components/Other-components/Search.vue'

  import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
  import ChatPage from '../module/interface-components/ChatPage.vue'
  import TicketButton from '../module/interface-components/TicketButton.vue'
  import OrderStatusCounter from '../module/special-components/Other-components/OrderStatusCounter.vue'
  import TableElement from '../module/special-components/Table-component/Table-Element.vue'
  import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'

  import {db} from '../../firebase'
  import _ from 'lodash'

export default {
  name: 'transferCompleted',
  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    Search,
    SidebarToggleButton,
    ChatPage,
    TicketButton,
    OrderStatusCounter,
    TableElement,
    LoadingRender
  },

  data () {
    return {
      transfers: [],
      fields: {
        transpName: '',
        orderRef: '',
        '.key': '',
        vin: '',
        creationDate: '',
        transmitterName: '',
        receiverName: '',
        status: ''
      },
      filterResults: [],
      searchHistory: [],
      searchType: '',
      searchText: '',
      historyTypeTag: '',
      fieldsObj: [
       {
         text: this.$t('TransferCompleted.carrier'),
         type: 'transpName',
         value: ''
       },
       {
         text: this.$t('TransferCompleted.reference'),
         type: 'orderRef',
         value: ''
       },
       {
         text: this.$t('TransferCompleted.order'),
         type: '.key',
         value: ''
       },
       {
         text: this.$t('TransferCompleted.VIN'),
         type: 'vin',
         value: ''
       },
       {
         text: this.$t('TransferCompleted.date'),
         type: 'creationDate',
         value: ''
       },
       {
         text: this.$t('TransferCompleted.pickup'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('TransferCompleted.delivery'),
         type: 'receiverName',
         value: ''
       },
       {
         text: this.$t('TransferCompleted.status'),
         type: 'status',
         value: ''
       }
      ]
    }
  },

  created () {
    this.isLoading = true
    this.$store.state.isSidebarOpen = false
    this.isScreenSmall = window.innerWidth < 800

    this.$bindAsArray('transfers', db.ref('transfer/transporter/' + this.companyUID + '/deliveries'), null, () => {
      this.isLoading = false
    })
    this.$bindAsArray('pending', db.ref('test/transporter/' + this.companyUID + '/pendingTransfer'))
  },

  methods: {
    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    evaluateFiltering (attr, val) {
      this.fields[attr] = val

      var isAttrDupe = false
      if (val === '') {
        return
      }
      this.searchHistory.find((o, i) => {
        if (o.searchType === attr) {
          var storedDupeTag = this.setSearchedItemTag(attr)
          this.searchHistory[i] = {
            searchType: attr, searchText: val, historyTypeTag: storedDupeTag}
          isAttrDupe = true
          return
        }
      })
      if (!isAttrDupe) {
        this.addSearchedItem(attr, val)
      }
    },

    setSearchedItemTag (attr) {
      var storedTag
      if (attr === 'transpName') { storedTag = this.$t('TransferCompleted.carrier') }
      if (attr === 'orderRef') { storedTag = this.$t('TransferCompleted.reference') }
      if (attr === '.key') { storedTag = this.$t('TransferCompleted.order') }
      if (attr === 'vin') { storedTag = this.$t('TransferCompleted.VIN') }
      if (attr === 'creationDate') { storedTag = this.$t('TransferCompleted.date') }
      if (attr === 'status') { storedTag = this.$t('TransferCompleted.status') }
      if (attr === 'transmitterName') { storedTag = this.$t('TransferCompleted.pickup') }
      if (attr === 'receiverName') { storedTag = this.$t('TransferCompleted.delivery') }
      return storedTag
    },

    addSearchedItem (searchedType, searchedText) {
      var storedTag = this.setSearchedItemTag(searchedType)
      this.searchHistory.push({searchType: searchedType, searchText: searchedText, historyTypeTag: storedTag})
    },

    removeSearchedItem (index, attr) {
      this.searchHistory.splice(index, 1)
      this.evaluateFiltering(attr, '')
    },

    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString()
    },

    onResize: _.debounce(function () {
      this.isScreenSmall = window.innerWidth < 800
    }, 50)
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },

  computed: {
    computed_newCount (newCount) {
      return newCount
    },

    companyUID () {
      return this.$store.state.authorization.company
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
.fa-exclamation{
  margin-left: 0.25rem;
}
</style>
